import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Popover from './Popover';

export default class RoomBookingCalendarHeader extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    attributes: PropTypes.array.isRequired,
  };

  render() {
    const wrapperProps = {
      className: 'BookingCalendar-header RoomSearch-roomColumn col',
      key: this.props.id,
    };

    if (this.props.attributes.length === 0) {
      return (
        <div {...wrapperProps}>
          <span className="BookingCalendar-roomName" title={this.props.name}>
            {this.props.name}
          </span>
        </div>
      );
    }

    return (
      <div {...wrapperProps}>
        {this.props.name}
        <Popover hover triggerClass="u-ml-2">
          <ul className="u-m-0 u-p-0">
            {this.props.attributes.map((attribute, index) => (
              <li className="u-m-0 u-p-0 u-list-inside u-list-disc" key={index}>
                {attribute}
              </li>
            ))}
          </ul>
        </Popover>
      </div>
    );
  }
}
